export const accreditations: { name: string; logo: string }[] = [
  { name: 'Accredited by the British Council', logo: 'https://cdn.magicpatterns.com/uploads/mRx52CFN5eeTEvZHNfisAQ/5-1.webp' },
  { name: 'Cambridge Assessment Authorised Centre', logo: 'https://cdn.magicpatterns.com/uploads/kfmFDfvWyey7281FgCpNzM/Untitled-design-44.webp' },
  { name: 'IELTS', logo: 'https://cdn.magicpatterns.com/uploads/dbt8tUXJgYWMkeYmUxG3mP/1.webp' },
  { name: 'English UK', logo: 'https://cdn.magicpatterns.com/uploads/4bqD1Haip3rP9CCRHzNpSj/6.webp' },
  { name: 'Dubai Knowledge', logo: 'https://cdn.magicpatterns.com/uploads/1jKF6QTD8wrZaqt1i65PQq/4.webp' },
  { name: 'ALTO', logo: 'https://cdn.magicpatterns.com/uploads/nEpYvg4nP4MkyTBXUcR4ua/2.webp' },
];
